@switch (eventType) {
  @case ('Culinair') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Culinair.svg'"></span>
  }
  @case ('Festivals') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Festivals.svg'"></span>
  }
  @case ('Bussines') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Bussines.svg'"></span>
  }
  @case ('Kunst & Cultuur') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Kunst & Cultuur.svg'"></span>
  }
  @case ('Markten & Fairs') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Markten & Fairs.svg'"></span>
  }
  @case ('Muziek & Theater') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Muziek & Theater.svg'"></span>
  }
  @case ('Natuur') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Natuur.svg'"></span>
  }
  @case ('Sport & actief') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Sport & Actief.svg'"></span>
  }
  @case ('Voor kinderen') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Voor kinderen.svg'"></span>
  }
  @case ('Informatief & Netwerk') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Other.svg'"></span>
  }
  @case ('Other') {
    <span class="icon" [inlineSVG]="'/icons/eventType/Other.svg'"></span>
  }
  @default {
    <span class="icon" [inlineSVG]="'/icons/eventType/Other.svg'"></span>
  }
}
<span class="text-primary-color">&nbsp;{{ eventType }}</span>
